import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  box-sizing: border-box;
  min-height: 60vh;
  max-height: calc(100vh - 182px);
  overflow: hidden;
  padding: ${props => props.theme.whiteLabel.spacing.sp8} ${props => props.theme.whiteLabel.spacing.sp8}
    ${props => props.theme.whiteLabel.spacing.sp24};

  @media screen and (min-width: 700px) {
    height: calc(100vh - 32px);
    max-height: calc(100vh - 32px);
  }
`
